/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_No_Results_DescriptionInputs */



/**
* | output |
* | --- |
* | "Adjust your search terms to find an agent." |
*
* @param {Agent_Builder_No_Results_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_no_results_description = /** @type {((inputs?: Agent_Builder_No_Results_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_No_Results_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passen Sie Ihre Suchbegriffe an, um einen Agenten zu finden.")
	return /** @type {LocalizedString} */ ("Adjust your search terms to find an agent.")
});